import React, { ChangeEvent, Ref, useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "./ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select"
import axios from "axios";
import { error, table } from "console";
import { Contact, ContactInfo, Matter } from "src/lib/conflix";

const apiUrl = process.env.REACT_APP_API_URL;

function StatusCell(
    props: {
        matter?: Matter;
        contact?: Contact;
        info?: ContactInfo;
        designation?: string;
        idToken: string;
        onLoading: (isLoading: boolean) => void;
        onUpdate: () => Promise<void>;
        onError: (err: string) => void;
    }
) {
    function GetInitValue() : string {
        if (props.matter && !props.contact) {
            return props.matter.status || "";
        } else {
            console.error("StatusCell requires a matter object");
            return "";
        }
    }

    const [editing, setEditing] = useState<boolean>(false);
    const [value, setValue] = useState<string>(GetInitValue());



    const onEditField = async (value: string) => {
        setValue(value);
        props.onLoading(true);

        if (props.matter) {
            const data = {
                name: props.matter.name,
                referenceNumber: props.matter.referenceNumber,
                status: value
            };

            await axios.put(
                `${apiUrl}matters/${props.matter.matterId}`,
                data,
                {
                    headers: {
                        Authorization: props.idToken,
                        "Content-Type": "application/json",
                    },
                }
            );
        }
        
        setEditing(false);
        props.onLoading(false);
        await props.onUpdate();
    };


    const onSelect = (e: React.MouseEvent<HTMLTableCellElement>) => {
        setEditing(true);
    };


    return (
        <TableCell
            className="font-medium"
            onDoubleClick={onSelect}
        >
            {editing ? (
                <Select
                    value={value}
                    onValueChange={onEditField}
                >
                    <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select Status" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="Open">Open</SelectItem>
                        <SelectItem value="Closed">Closed</SelectItem>
                    </SelectContent>
                </Select>
            ) : (
                value
            )}
        </TableCell>
    );
}

export default StatusCell;
